module.exports = __webpack_public_path__ + "img/turns.cc2a4e8e.svg";